import CodeMirror, { EditorView } from "@uiw/react-codemirror";
import { useDebounce } from "@uidotdev/usehooks";
import { useState, useEffect, useCallback } from "react";
import { html as cmHtml } from "@codemirror/lang-html";
import { javascript as cmJs } from "@codemirror/lang-javascript";
import cn from "classnames";

import "./index.css";

export function App() {
  const [html, setHtml] = useState(localStorage.getItem("html") ?? "");
  const [js, setJs] = useState(localStorage.getItem("js") ?? "");
  const [dark, setDark] = useState(true);
  const [waitingHtml, setWaitingHtml] = useState(false);
  const [waitingJs, setWaitingJs] = useState(false);

  const delayedHtml = useDebounce(html, 1000);
  useEffect(() => {
    localStorage.setItem("html", delayedHtml);
    setWaitingHtml(false);
  }, [delayedHtml]);

  const delayedJs = useDebounce(js, 1000);
  useEffect(() => {
    localStorage.setItem("js", delayedJs);
    setWaitingJs(false);
  }, [delayedJs]);

  const onUpdateHtml = useCallback(
    (html: string) => {
      setWaitingHtml(true);
      setHtml(html);
    },
    [html, setHtml],
  );
  const onUpdateJs = useCallback(
    (js: string) => {
      setWaitingJs(true);
      setJs(js);
    },
    [js, setJs],
  );

  return (
    <main className="flex h-screen relative">
      <div
        className={cn(
          "flex flex-col h-full w-1/2 resize-x overflow-x-auto overflow-y-hidden ",
          !dark && "border-r-3 border-green-400 bg-green-400",
        )}
      >
        <CodeMirror
          className={cn(
            "h-1/2 [&_.cm-editor]:h-full whitespace-pre-wrap resize-y overflow-auto border-b-3 border-transparent rounded-br-lg",
          )}
          theme={dark ? "dark" : "light"}
          value={html}
          onChange={onUpdateHtml}
          extensions={[cmHtml(), EditorView.lineWrapping]}
        />
        <CodeMirror
          className="flex-1 [&_.cm-editor]:h-full whitespace-pre-wrap overflow-auto rounded-tr-lg"
          theme={dark ? "dark" : "light"}
          value={js}
          onChange={onUpdateJs}
          extensions={[cmJs(), EditorView.lineWrapping]}
        />

        <div className="absolute right-1 top-1 flex gap-1">
          <button
            className="cursor-pointer bg-slate-900 rounded px-1"
            onClick={() => setDark((dark) => !dark)}
          >
            🌙
          </button>
          <div className="rounded px-1 bg-slate-500 cursor-default">
            {waitingHtml || waitingJs ? "🕑" : "✅"}
          </div>
        </div>
      </div>

      <iframe
        className="flex-1 h-full"
        srcDoc={`<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width"></head><body>${delayedHtml}<script>${delayedJs}</script></body></html>`}
      />
    </main>
  );
}

export default App;
